module.exports = __webpack_public_path__ + "img/bgc13.d479e2c3.png";